namespace OfficeGuy.Inputs {
    export class Password {
        static Toggle($Toggle): boolean {
            $Toggle.toggleClass("sumit-input-password-toggle-visible");
            $Toggle.parent().find("input").attr("type", $Toggle.hasClass("sumit-input-password-toggle-visible") ? "text" : "password");
            return false;
        }
    }
}
